import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import {
  PageLogin,
  PagePwdReset,
  PagePwdResetMail,
} from './pages';
import PageActivateMail from './pages/PageActivateMail.jsx';
import PageSetPwd from './pages/PageSetPwd.jsx';
import { env } from '~/commons/config';
import PageNotFound from '~/commons/components/PageNotFound.jsx';
import CookiePolicy from '~/commons/components/CookiePolicy.jsx';
import { Nav } from './layout/Nav.jsx';
import PageUser from './pages/PageUser.jsx';
import { AlertProvider } from '../../commons/components/alert/index.jsx';
import PageStocks from './pages/PageStocks.jsx';
import PageStock from './pages/PageStock.jsx';
import PageShareStocks from './pages/PageShareStocks.jsx';
import PageShareStock from './pages/PageShareStock.jsx';

const App = () => {
  
  const roles = _.get(env, 'user.roles');
  if (_.isEmpty(roles)) {
    return (
      <div className="d-flex content-100">
        <div className="my-auto w-100">
          <Router>
            <Switch>
              <Route path="/portal/auth/pwd-recovery" exact>
                <PagePwdResetMail />
              </Route>
              <Route path="/portal/auth/pwd-reset" exact>
                <PagePwdReset />
              </Route>
              <Route path="/portal/auth/activate" exact>
                <PageActivateMail />
              </Route>
              <Route path="/portal/auth/pwd-set" exact>
                <PageSetPwd />
              </Route>
              <Route path="/portal" exact>
                <PageLogin />
              </Route>
              <Route path="*">
                <PageNotFound autoRedirect='/portal' />
              </Route>
            </Switch>
            <CookiePolicy />
          </Router>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid h-100">
      <div className="row h-100">
        <Router>
          <Nav />
          <div className="col">
            <div className="px-4">
              <Switch>
                <Route path="/portal" exact>
                  <Redirect to="/portal/stocks" />
                </Route>
                <Route path="/portal/user/" exact>
                  <PageUser />
                </Route>
                <Route path="/portal/stocks/" exact>
                  <PageStocks />
                </Route>
                <Route path="/portal/stocks/:_id" exact>
                  <PageStock />
                </Route>
                {!_.isEqual(roles, ['customer']) && <Route path="/portal/shareStocks/" exact>
                  <PageShareStocks />
                </Route>}
                {!_.isEqual(roles, ['customer']) && <Route path="/portal/shareStocks/:_id" exact>
                  <PageShareStock />
                </Route>}
                <Route path="*">
                  <PageNotFound autoRedirect='/portal/stocks' />
                </Route>
              </Switch>
            </div>
          </div>
        </Router>
      </div>
    </div>
  );
}

const ProviderChain = ({
  providers = [],
  children
}) => _.reduceRight(providers, (children, Provider) => <Provider>{children}</Provider>, children);

const appProviders = [
  AlertProvider,
]

export default () => <ProviderChain providers={appProviders}><App /></ProviderChain>;
